import listed01 from "../imgs/tokenRelease/release-item1.png";
import listed02 from "../imgs/tokenRelease/release-item2.png";
import listed03 from "../imgs/tokenRelease/release-item3.png";
import listed04 from "../imgs/tokenRelease/release-item4.png";
import listed05 from "../imgs/tokenRelease/release-item5.png";
import listed06 from "../imgs/tokenRelease/release-item6.png";
import listed07 from "../imgs/tokenRelease/release-item7.png";
import listed08 from "../imgs/tokenRelease/release-item8.png";

export const listedImg = [
    listed01,
    listed02,
    listed03,
    listed04,
    listed05,
    listed06,
    listed07,
    listed08,
];
